var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngularJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 100,
    viewBox: "0 0 93 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0L0 16.6L7.09237 78.15L46.5 100L85.9076 78.15L93 16.6L46.5 0Z",
    fill: "#DD0031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0V11.1V11.05V61.7V100L85.9076 78.15L93 16.6L46.5 0Z",
    fill: "#C3002F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5004 11.0498L17.4316 76.2998H28.27L34.1137 61.6998H58.7872L64.6309 76.2998H75.4692L46.5004 11.0498ZM54.9913 52.6998H38.0095L46.5004 32.2498L54.9913 52.6998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularJs);
export default __webpack_public_path__ + "static/media/AngularJS.e3e381d50487ec65d2bbc68171fd525d.svg";
export { ForwardRef as ReactComponent };